import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '请求参数',
    type: 'ALG_INPUT',
}
